// Weekly champion — last week's #1 daily player. Cached briefly per session.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export async function fetchWeeklyChampion() {
  if (cache) return cache;
  try {
    const res = await axios.get(`${API}/champion/weekly`);
    cache = res.data || null;
    return cache;
  } catch {
    return null;
  }
}

// True if `name` is the current weekly champion.
export function isChampionName(champion, name) {
  if (!champion || !champion.player_name || !name) return false;
  return champion.player_name.trim().toUpperCase() === name.trim().toUpperCase();
}
